import b from 'b_';
import React from 'react';
import { useSelector } from 'react-redux';

import { QuizOption } from '../__option/quiz__option';
import { UI_KIT_HEADER_TYPOGRAPHY } from '../../constants';
import { H1 } from '../../header-text/header-text';
import { getMaxResult, getQuestionResults, getRightAnswerIndex } from '../selectors';
import { Answer, CARD_COLORS } from '../typings';

import './quiz__question-statistics.scss';

interface Props {
    answers: Answer[];
    title: string;
}

export const QuizQuestionStatistics = ({ answers, title }: Props) => {
    const questionResults = useSelector(getQuestionResults);
    const maxResult = useSelector(getMaxResult);
    const rightAnswerIndex = useSelector(getRightAnswerIndex);

    return (
        <div className="quiz-teacher__statistics-wrapper">
            <H1 mix="quiz-teacher__statistics-title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineLMedium}>
                {title}
            </H1>

            <div className="quiz-teacher__statistics-results">
                {questionResults &&
                    Boolean(maxResult) &&
                    questionResults.map((answersCount, index) => {
                        const columnHeight = maxResult ? (answersCount * 100) / maxResult : 0;
                        const columnColor = CARD_COLORS[index];
                        const isHidden = !columnHeight;

                        return (
                            <div
                                className={b('quiz-teacher__stat-column-wrapper', {
                                    correct: Boolean(index === rightAnswerIndex),
                                    hidden: isHidden,
                                })}
                                data-answers-count={answersCount}
                                key={columnColor}
                                style={{
                                    height: `${columnHeight}%`,
                                }}
                            >
                                <div className={b('quiz-teacher__stat-column-background', { color: columnColor })} />
                            </div>
                        );
                    })}
            </div>
            <div className="quiz-teacher__statistics">
                {answers.map((answer, index) => (
                    <QuizOption
                        color={CARD_COLORS[index]}
                        key={answer.value}
                        mix={b('quiz-teacher__statistics-option', {
                            right: Boolean(answer.correct),
                        })}
                        option={answer.value}
                    />
                ))}
            </div>
        </div>
    );
};
